<template>
	<v-dialog v-model="isVisible" max-width="500">
		<p-card class="tw-p-none overflow-hidden">
			<div class="tw-flex tw-justify-start tw-p-3"
				:style="`color:${$appColors.primary};`">
				<h3>Cambio de estado de Proceso de Reclutamiento</h3>
			</div>
			<section class="tw-flex tw-flex-col tw-justify-between tw-gap-3 tw-p-6">
				<v-select
					solo
					class="custom-select-form"
					autocomplete
					:items="states"
					item-text="name"
					item-value="id"
					v-model="statusEdit"
				></v-select>
			</section>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					type="primary"
					@click="changeStatus"
					>Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';

export default {
	name: 'change-status-dialog',
	beforeCreate() {
	},
	created() {
	},
	mounted() {
		// this.$nextTick(() => {
		// 	this.statusEdit = this.status;
		// });
	},
	data() {
		return {
			isVisible: false,
			states: [
				{
					id: 0,
					name: 'Borrador',
				},
				{
					id: 1,
					name: 'Publicado',
				},
				{
					id: 2,
					name: 'Finalizado',
				},
			],
			statusEdit: null,
		};
	},
	components: { PButton, PCard },
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		changeStatus() {
			this.$emit('changeValueStatus', this.statusEdit);
			this.isVisible = false;
		},
	},
	computed: {
	},
	props: {
		status: {
			type: Number,
			default: null,
		},
	},
	watch: {
		status: {
			handler(newVal) {
				this.statusEdit = newVal;
			},
			deep: true,
		},
	},
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/change-status-dialog.vue